/**
 * @fileoverview GET handler for the "/sdk/debugger/:recording_id/session" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { sdkDebuggerRecordingId } from "./constants";
import type { SdkDebuggerRecordingIdResult } from "./types";

export const getSdkDebuggerRecordingId = reactQueryFetcherAdapter(
  sdkDebuggerRecordingId,
  (signal: AbortSignal, recordingId: string): Promise<SdkDebuggerRecordingIdResult> => {
    return fetch(`/sdk/debugger/${recordingId}/session`, "GET", {}, { signal });
  }
);
